module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(typeof _vm.customer !== 'undefined') ? _c('span', [(!_vm.present) ? _c('span', [(_vm.customer.contacts.filter(function (contact) { return contact.name && contact.name.trim() !== ''; }).map(function (contact) { return contact.name; }).join('').trim() !== '') ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "right",
      "content": _vm.customer.contacts.filter(function (contact) { return contact.name && contact.name.trim() !== ''; }).map(function (contact) { return contact.name; }).join(', ')
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/customers/' + _vm.customer.id
    }
  }, [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "icon"
    }
  }), _vm._v("\n            " + _vm._s(_vm.customer.name) + " (" + _vm._s(_vm.customer.address.zip_code) + ")\n          ")], 1)], 1), _vm._v(" "), _c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "badges"
    }
  })], 1) : _c('span', [_c('router-link', {
    attrs: {
      "to": '/customers/' + _vm.customer.id
    }
  }, [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "icon"
    }
  }), _vm._v("\n          " + _vm._s(_vm.customer.name) + " (" + _vm._s(_vm.customer.address.zip_code) + ")\n          "), _c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "badges"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.present === 'minimal') ? _c('span', [_c('router-link', {
    attrs: {
      "to": '/customers/' + _vm.customer.id
    }
  }, [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "icon"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.present === 'icon') ? _c('span', [(_vm.customer.job_type === 'Marchand de biens') ? _c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "title": "Marchand de biens"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customer.job_type === 'Métier de la construction') ? _c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "title": "Métier de la construction"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customer.job_type === 'Travaux et rénovation') ? _c('i', {
    staticClass: "fa fa-wrench",
    attrs: {
      "title": "Travaux et rénovation"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.present === 'option') ? _c('span', [_c('el-option', {
    attrs: {
      "label": _vm.customer.name + ' (' + _vm.customer.address.zip_code + ')',
      "value": _vm.customer.id
    }
  }, [_c('span', {
    class: {
      'text-muted': !_vm.isOurCustomer()
    },
    style: ({
      float: 'left'
    })
  }, [_vm._v("\n          " + _vm._s(_vm.customer.name + ' (' + _vm.customer.address.zip_code + ')') + "\n\n          "), _c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "badges"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "sources"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.present === 'badges') ? _c('span', [_c('span', {
    staticStyle: {
      "color": "#bbb"
    }
  }, [(_vm.customer.services.length > 0) ? _c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "title": "Services"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasSourceField('comments')) ? _c('i', {
    staticClass: "fa fa-comment",
    attrs: {
      "title": "Commentaires"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customer.contacts.length > 0) ? _c('i', {
    staticClass: "fa fa-address-card",
    attrs: {
      "title": "Contacts"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOurCustomer()) ? _c('i', {
    staticClass: "fa fa-handshake-o",
    attrs: {
      "title": "Dans mon parc"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.present === 'sources') ? _c('span', [_c('span', {
    staticStyle: {
      "color": "#8492a6",
      "font-size": "0.8em"
    }
  }, [(_vm.customer.sources['devis-b2b']) ? _c('span', [_c('source-app', {
    attrs: {
      "name": "devis-b2b",
      "size": "tiny"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.customer.sources['sellsy-comweb']) ? _c('span', [_c('source-app', {
    attrs: {
      "name": "sellsy-comweb",
      "size": "tiny"
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.present === 'name') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.customer.name) + "\n      "), (_vm.customer.public.name) ? _c('span', [_vm._v("\n        (" + _vm._s(_vm.customer.public.name) + ")\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.present === 'job') ? _c('span', [_c('customer', {
    attrs: {
      "item": _vm.customer,
      "present": "icon"
    }
  }), _vm._v(" " + _vm._s(_vm.customer.job_type) + "\n      "), (_vm.customer.job) ? _c('span', [_vm._v("(" + _vm._s(_vm.customer.job) + ")")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.present === 'city') ? _c('span', [_c('i', {
    staticClass: "fa fa-map-marker text-muted"
  }), _vm._v(" " + _vm._s(_vm.customer.address.city) + " (" + _vm._s(_vm.customer.address.zip_code) + ")\n    ")]) : _vm._e(), _vm._v(" "), (_vm.present === 'first_phone') ? _c('span', [_c('i', {
    staticClass: "fa fa-phone text-muted"
  }), _vm._v(" " + _vm._s(_vm.customer.contact_details.first_phone) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.present === 'second_phone') ? _c('span', [_c('i', {
    staticClass: "fa fa-phone text-muted"
  }), _vm._v(" " + _vm._s(_vm.customer.contact_details.second_phone) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.present === 'email') ? _c('span', [_c('i', {
    staticClass: "fa fa-envelope-o text-muted"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.customer.contact_details.email
    }
  }, [_vm._v(_vm._s(_vm.customer.contact_details.email))])]) : _vm._e(), _vm._v(" "), (_vm.present === 'website') ? _c('span', [_c('i', {
    staticClass: "fa fa-link text-muted"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.customer.contact_details.website
    }
  }, [_vm._v("Site internet")])]) : _vm._e(), _vm._v(" "), (_vm.present === 'remarks') ? _c('span', [_c('i', {
    staticClass: "fa fa-commenting text-muted"
  }), _vm._v(" infos importantes:\n      "), (_vm.customer.contact_details.remarks) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.customer.contact_details.remarks) + "\n      ")]) : _c('span', [_vm._v("\n        /\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.present === 'contacts') ? _c('span', [_c('ul', {
    staticClass: "ul-fa"
  }, _vm._l((_vm.customer.contacts), function(contact) {
    return _c('li', {
      key: contact.id,
      staticStyle: {
        "padding": "0"
      }
    }, [_c('el-popover', {
      attrs: {
        "placement": "right",
        "width": "300",
        "trigger": "hover",
        "title": contact.name
      }
    }, [_c('div', [_c('div', [_vm._v("Téléphone 1 : " + _vm._s(contact.first_phone))]), _vm._v(" "), _c('div', [_vm._v("Téléphone 2 : " + _vm._s(contact.second_phone))]), _vm._v(" "), _c('div', [_vm._v("Email : " + _vm._s(contact.email))])]), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('source-app', {
      attrs: {
        "name": contact.source,
        "size": "tiny"
      }
    }), _vm._v("\n              " + _vm._s(contact.name) + "\n            ")], 1)])], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.present === 'services') ? _c('span', [_c('ul', {
    staticClass: "ul-fa"
  }, _vm._l((_vm.customer.services), function(service) {
    return (typeof(service.end_at) === 'undefined' || _vm.moment(service.end_at.date).isAfter(_vm.moment())) ? _c('li', {
      key: service.id
    }, [_c('source-app', {
      attrs: {
        "name": service.source,
        "size": "tiny"
      }
    }), _vm._v(" " + _vm._s(service.name) + "\n          "), (typeof(service.end_at) !== 'undefined' && _vm.moment(service.end_at.date).diff(_vm.moment(), 'days') < 30) ? _c('span', [_c('el-tooltip', {
      attrs: {
        "content": "Le service expire dans moins d'un mois",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle text-danger"
    })])], 1) : (typeof(service.end_at) !== 'undefined' && _vm.moment(service.end_at.date).diff(_vm.moment(), 'days') < 60) ? _c('span', [_c('el-tooltip', {
      attrs: {
        "content": "Le service expire dans moins de deux mois",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle text-warning"
    })])], 1) : _vm._e()], 1) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.present === 'analyze') ? _c('span', [(_vm.customer.meta && _vm.customer.meta.commercial && _vm.customer.meta.commercial.statistics) ? _c('span', [_vm._v("\n        Du " + _vm._s(_vm.moment(_vm.customer.meta.commercial.statistics.range.from).format('DD/MM/YYYY')) + "\n        au " + _vm._s(_vm.moment(_vm.customer.meta.commercial.statistics.range.to).format('DD/MM/YYYY')) + " :\n        "), _c('ul', [(_vm.customer.meta.commercial.statistics.prices.quotes_lt) ? _c('li', {
    class: [_vm.customer.meta.commercial.statistics.prices.quotes_lt > 15 ? 'text-danger' : 'text-success']
  }, [_vm._v("\n            " + _vm._s(_vm.customer.meta.commercial.statistics.prices.quotes_lt) + " € / Lead LT\n          ")]) : _vm._e(), _vm._v(" "), (_vm.customer.meta.commercial.statistics.prices.ads_cpc) ? _c('li', {
    class: [_vm.customer.meta.commercial.statistics.prices.ads_cpc > 2 ? 'text-danger' : 'text-success']
  }, [_vm._v("\n            Pubs " + _vm._s(_vm.customer.meta.commercial.statistics.prices.ads_cpc) + " € CPC (" + _vm._s(_vm.customer.meta.commercial.statistics.prices.ads_cpm) + " € CPM)\n          ")]) : _vm._e(), _vm._v(" "), (_vm.customer.meta.commercial.statistics.prices.grounds_email) ? _c('li', {
    class: [_vm.customer.meta.commercial.statistics.prices.grounds_email > 18 ? 'text-danger' : 'text-success']
  }, [_vm._v("\n            " + _vm._s(_vm.customer.meta.commercial.statistics.prices.grounds_email) + " € / Email Annonce\n          ")]) : _vm._e()])]) : _c('span', [_vm._v("\n        Aucune analyse.\n      ")])]) : _vm._e()]) : _c('span', [_c('pulse-loader', {
    attrs: {
      "color": "#cccccc",
      "size": "8px"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59ed46d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Customer.vue
// module id = 696
// module chunks = 1